// extracted by mini-css-extract-plugin
module.exports = {"input":"ResetPassword_input__301sH","success":"ResetPassword_success__3-p5i"};